module.exports = __webpack_public_path__ + "img/symbol_10.74ee5d06.png";